module.exports = __webpack_public_path__ + "img/39.57f3148a.png";